// import {
//   SEARCHFILTER_CREATE_ACTIONS,
//   SEARCHFILTER_LIST_ACTIONS,
//   SEARCHFILTER_EDIT_ACTIONS,
//   SEARCHFILTER_DELETE_ACTIONS,
// } from "../../../actionsType";
// import { ADMIN_SEARCHFILTER_ACTIONS } from "../../../actionsType/admin/searchFilter";

import { ADMIN_SEARCHFILTER_ACTIONS } from "../../../actionType/admin/searchFilter";

const intialState = {
  searchFilterCreatData: {},
  isSearchFilterCreatLoader: false,
  searchFilterMarkedData: {},
  isSearchFilterMarkLoader: false,
  searchFilterList: [],
  isSearchFilterListLoader: false,
  searchFilterDeleteLoader: false,
  searchFilterDeleteData: {},
};

export const adminSearchFilterReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_REQUEST:
      return { ...state, isSearchFilterCreatLoader: true };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_RESPONSE:
      return {
        ...state,
        searchFilterCreatData: payload,
        isSearchFilterCreatLoader: false,
      };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_ERROR:
      return {
        ...state,
        searchFilterCreatData: payload,
        isSearchFilterCreatLoader: false,
      };

    // SEARCHFILTER_LIST_ACTIONS

    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_LIST_REQUEST:
      return { ...state, isSearchFilterListLoader: true };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_RESPONSE:
      return {
        ...state,
        searchFilterList: payload,
        isSearchFilterListLoader: false,
      };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_LIST_RESPONSE:
      return {
        ...state,
        searchFilterList: payload,
        isSearchFilterListLoader: false,
      };


    // MARKED_SEARCHFILTER_LIST_ACTIONS

    case ADMIN_SEARCHFILTER_ACTIONS.MARK_FEATURED_REQUEST:
      return { ...state, isSearchFilterMarkLoader: true };
    case ADMIN_SEARCHFILTER_ACTIONS.MARK_FEATURED_RESPONSE:
      return {
        ...state,
        searchFilterMarkedData: payload,
        isSearchFilterMarkLoader: false,
      };
    case ADMIN_SEARCHFILTER_ACTIONS.MARK_FEATURED_ERROR:
      return {
        ...state,
        searchFilterMarkedData: payload,
        isSearchFilterMarkLoader: false,
      };

    // SEARCHFILTER_EDIT_ACTIONS

    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_EDIT_REQUEST:
      return { ...state, isSearchFilterCreatLoader: true };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_EDIT_RESPONSE:
      return {
        ...state,
        searchFilterCreatData: payload,
        isSearchFilterCreatLoader: false,
      };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_EDIT_ERROR:
      return {
        ...state,
        searchFilterCreatData: payload,
        isSearchFilterCreatLoader: false,
      };
    // SEARCHFILTER_DELETE_ACTIONS

    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_DELETE_REQUEST:
      return { ...state, searchFilterDeleteLoader: true };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_DELETE_REQUEST:
      return {
        ...state,
        searchFilterDeleteData: payload,
        searchFilterDeleteLoader: false,
      };
    case ADMIN_SEARCHFILTER_ACTIONS.SEARCHFILTER_DELETE_ERROR:
      return {
        ...state,
        searchFilterDeleteData: payload,
        searchFilterDeleteLoader: false,
      };
    default:
      return state;
  }
};
